var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"m-0 p-0 text-2xl leading-[58px] tracking-normal font-medium uppercase",class:_vm.color},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }